import { PostPayeeReportForm } from './types';
import { downloadResponse } from 'src/utils/downloadResponse';
import { fetchWithErrorThrowing } from 'ck-utils';
import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

export const useReportPaymentReceiverDownload = () => {
  return useMutation({
    mutationFn: (data: PostPayeeReportForm) =>
      toast.promise(postReportPaymentReceiverDownload(data), {
        loading: 'Laddar...',
        success: 'Rapport exporterad',
        error: 'Kunde inte exportera rapport',
      }),
  });
};

const postReportPaymentReceiverDownload = async (data: PostPayeeReportForm) => {
  return fetchWithErrorThrowing('/report/payment-receiver/download', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: new Headers({
      'content-type': 'application/json',
    }),
  })
    .then(async (response) => {
      downloadResponse(
        response,
        `betalningsmottagare_${data.from.split('T')[0]}_${
          data.to.split('T')[0]
        }`
      );
    })
    .catch((e) => console.log(e));
};
